class CustomSlideshow {
  constructor(container) {
    this.container = container;
    this.emblaNode = container.querySelector(".custom-slideshow-embla");
    if (!this.emblaNode) return;

    this.autoplay = container.dataset.autoplay === "true";
    this.autoplaySpeed = parseInt(container.dataset.autoplaySpeed) || 5000;
    this.autoPlayInterval = null;

    this.emblaApi = EmblaCarousel(this.emblaNode, { loop: true });

    if (this.autoplay) {
      this.startAutoplay();

      this.container.addEventListener("mouseenter", () => this.stopAutoplay());
      this.container.addEventListener("mouseleave", () => this.startAutoplay());
    }
  }

  startAutoplay() {
    if (this.autoPlayInterval) return;
    this.autoPlayInterval = setInterval(
      () => this.emblaApi.scrollNext(),
      this.autoplaySpeed
    );
  }

  stopAutoplay() {
    clearInterval(this.autoPlayInterval);
    this.autoPlayInterval = null;
  }
}

document.addEventListener("DOMContentLoaded", () => {
  document
    .querySelectorAll(".custom-slideshow")
    .forEach((el) => new CustomSlideshow(el));
});
